export default __webpack_public_path__ + "66512a554779d0c87cfa5b4e84a95009.mp3";